/* unplugin-vue-components disabled */import script from "./NotificaTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificaTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NotificaTableBlock.vue?vue&type=style&index=0&id=2b704a37&scoped=true&lang=less"
import "./NotificaTableBlock.vue?vue&type=style&index=1&id=2b704a37&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b704a37"]])

export default __exports__